import type { Currency } from '../types/index.js'

export const EUR: Currency = {
  code: 'EUR',
  decimals: 2,
  label: 'Euro',
  symbol: '€',
}

export const USD: Currency = {
  code: 'USD',
  decimals: 2,
  label: 'US Dollar',
  symbol: '$',
}

export const GBP: Currency = {
  code: 'GBP',
  decimals: 2,
  label: 'British Pound',
  symbol: '£',
}
